import { MouseEvent, useRef, useState } from "react";

// Mouse-following aqua glow orb for the gamified glow buttons (start / approve /
// delete) — port of the design system's pf-glow-orb. Returns a ref for the button,
// the pointer handlers, and the orb element to render as the button's FIRST child
// (it sits behind the content at z-index 0). Idle oscillation + prefers-reduced-motion
// live in CSS (.btn-glow-orb); approve/delete recolor the orb white there too.
export function useGlowOrb() {
  const ref = useRef<HTMLButtonElement>(null);
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);
  const [hover, setHover] = useState(false);

  const handlers = {
    onMouseMove: (e: MouseEvent<HTMLButtonElement>) => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      setPos({ x: e.clientX - r.left, y: e.clientY - r.top });
    },
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
  };

  const orb = (
    <span
      className={"btn-glow-orb " + (hover ? "btn-orb-hover" : "btn-orb-idle")}
      aria-hidden="true"
      style={
        hover && pos
          ? { left: pos.x, top: pos.y, transform: "translate(-50%, -50%) scale(1.15)" }
          : undefined
      }
    />
  );

  return { ref, handlers, orb };
}
